import {type PropsWithChildren, createContext, use, useMemo} from 'react'

export type StaticContextType = {
  isPreview?: boolean
  isCondensed?: boolean
}
export const StaticContext = createContext<StaticContextType | undefined>(undefined)

export function StaticProvider({children, isPreview, isCondensed}: PropsWithChildren<StaticContextType>) {
  isPreview = isPreview ?? false
  isCondensed = isCondensed ?? false

  const value = useMemo(
    () => ({
      isPreview,
      isCondensed,
    }),
    [isPreview, isCondensed],
  )
  return <StaticContext value={value}>{children}</StaticContext>
}

export function useStatic(): StaticContextType {
  const context = use(StaticContext)
  if (!context) {
    throw new Error('useStatic must be used within a StaticProvider')
  }
  return context
}
